import { Modelo } from '@ext/index';
import * as Types from './Imagenes.types';
import moment, { Moment } from 'moment';

export class IImagen extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: number = 0;
    public Articulo: string = '';
    public Tipo: string = '';
    public Resolucion: string = '';
    public Archivo: string = '';
    public Miniatura: string = '';
    public Archivo500: string = '';
    public Archivo1000: string = '';

    public DescargarArchivo: string = '';
    public DescargarMiniatura: string = '';
    public DescargarArchivo500: string = '';
    public DescargarArchivo1000: string = '';

    public get esPrincipal()
    {
        return this.Tipo == 'principal';
    }


    public getJson(): any
    {
        let json: any = {};

        json.id = this.Id;
        json.articulo = this.Articulo;
        json.tipo = this.Tipo;
        json.resolucion = this.Resolucion;
        json.archivo = this.Archivo;


        return json;
    }


    public set(): boolean
    {

        this.Id = !this.Json.id ? 0 : this.Json.id;
        this.Articulo = !this.Json.articulo ? '' : this.Json.articulo;
        this.Tipo = !this.Json.tipo ? '' : this.Json.tipo;
        this.Resolucion = !this.Json.resolucion ? '' : this.Json.resolucion;
        this.Archivo = !this.Json.archivo ? '' : this.Json.archivo;
        this.Miniatura = !this.Json.archivo_thumbnail ? '' : this.Json.archivo_thumbnail;
        this.Archivo500 = !this.Json.archivo_500 ? '' : this.Json.archivo_500;
        this.Archivo1000 = !this.Json.archivo_1000 ? '' : this.Json.archivo_1000;

        this.DescargarArchivo = !this.Json.descargar_archivo ? '' : this.Json.descargar_archivo;
        this.DescargarMiniatura = !this.Json.descargar_archivo_thumbnail ? '' : this.Json.descargar_archivo_thumbnail;
        this.DescargarArchivo500 = !this.Json.descargar_archivo_500 ? '' : this.Json.descargar_archivo_500;
        this.DescargarArchivo1000 = !this.Json.descargar_archivo_1000 ? '' : this.Json.descargar_archivo_1000;


        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: IImagen )
    {
        this.Model = Model;
    }

    public Model: IImagen;
}